import { LeadDashboard } from '~/models/LeadDashboard'
import { TripWidgetEntityMapper } from '../trip/widget/entityMapper'
import { ApiLeadDashboard } from './apiTypes'

export class LeadDashboardApiMapper {
	static toLeadDashboard(apiLeadDashboard: ApiLeadDashboard): LeadDashboard {
		return {
			tripCover: apiLeadDashboard.trip_cover,
			tripTitle: apiLeadDashboard.trip_title,
			itineraryId: apiLeadDashboard.itinerary_id,
			widgets: TripWidgetEntityMapper.toTripWidgets(apiLeadDashboard.widgets),
			enterpriseLogo: apiLeadDashboard.enterprise_logo,
			assistantName: apiLeadDashboard.assistant_name,
		}
	}
}
